<template>
  <div
  id="sendbox"
  class="page page-on-center close-picker"
  data-page="sendbox-page" @ptr:refresh="onPullToRefresh()">

  <div class="showSmallScreenOnly" v-bind:class="colorBottomButton">
    <f7-fab class="leftfav2 button-fab bottomButton floatingButtonToolbarBlank" @click="openCreateRequest">
      <f7-icon f7="add"></f7-icon>
    </f7-fab>
    <!-- Extract RTP -->
    <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="extractCSV(sendboxMessages)" v-if="currentTAB === 'sent'">
      <f7-icon f7="document_text"></f7-icon>
    </f7-fab>
    <!-- TODO Refresh RTP -->
    <f7-fab class="leftfav3 button-fab bottomButton floatingButtonToolbarBlank" @click="refreshSentRTP()" v-if="currentTAB === 'sent'">
      <f7-icon f7="refresh"></f7-icon>
    </f7-fab>
    <!-- TODO Import RTP -->
    <f7-fab class="leftfav4 button-fab bottomButton floatingButtonToolbarBlank" href="#" v-if="currentTAB === 'sent' && isAdmin">
      <f7-icon f7="list_bullet"></f7-icon>
    </f7-fab>
    <!-- TODO Extract Drafts -->
    <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank" @click="" v-if="currentTAB === 'draft'">
      <f7-icon f7="document_text"></f7-icon>
    </f7-fab>
    <!-- TODO Refresh Drafts -->
    <f7-fab class="leftfav3 button-fab bottomButton floatingButtonToolbarBlank" @click="refreshDrafts()" v-if="currentTAB === 'draft'">
      <f7-icon f7="refresh"></f7-icon>
    </f7-fab>
    <!-- TODO Import Drafts -->
    <f7-fab class="leftfav4 button-fab bottomButton floatingButtonToolbarBlank" href="#" v-if="currentTAB === 'draft'">
      <f7-icon f7="list_bullet"></f7-icon>
    </f7-fab>
  </div>
  <div class="page-content filterHeight heightifLargeScreen"
       style="z-index:9;">
    <page-nav-bar
      v-bind:currentServiceName="serviceName"
      popoverName=".popoverSendbox"
      subNavTitle="Sent Requests to Pay"
      :menuAccess="true"
      :paymentsNumber="paymentsNumber">
    </page-nav-bar>

    <div class="row rowBackgroundImage showLargeScreenOnly">
      <div class="row rowSearchBar" v-bind:class="colorBottomButton">
        <div class="firstButtonMarginLeft showLargeScreenOnly">
          <button class="new-button milkyBlock boxRequest" @click="openCreateRequest">
            <f7-icon f7="add"></f7-icon>
            <span>Create New Request</span>
          </button>
          <!-- TODO Extract RTP -->
          <button class="milkyBlock new-button boxRequest" @click="extractCSV(sendboxMessages)" v-if="currentTAB === 'sent'">
            <f7-icon f7="document_text"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Extract CSV</span>
          </button>
          <!-- TODO Refresh RTP -->
          <button class="milkyBlock new-button boxRequest" @click="refreshSentRTP()" v-if="currentTAB === 'sent'">
            <f7-icon f7="refresh"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Refresh</span>
          </button>
          <!-- TODO Import RTP -->
          <button class="milkyBlock new-button boxRequest" @click="" v-if="currentTAB === 'sent' && isAdmin">
            <f7-icon f7="list_bullet"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Import</span>
          </button>
          <!-- TODO Extract Drafts -->
          <button class="milkyBlock new-button boxRequest" @click="extractDraftsCSV()" v-if="currentTAB === 'draft'">
            <f7-icon f7="document_text"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Extract CSV</span>
          </button>
          <!-- TODO Refresh Drafts -->
          <button class="milkyBlock new-button boxRequest" @click="refreshDrafts()" v-if="currentTAB === 'draft'">
            <f7-icon f7="refresh"></f7-icon>
            <span class="showLargeScreenOnly fab-label">Refresh</span>
          </button>
          <!-- TODO Import Drafts -->
          <button class="milkyBlock new-button boxRequest" @click="" v-if="currentTAB === 'draft'">
            <i class="icon-server_out icon icon-float-sub-button"></i>
            <span class="showLargeScreenOnly fab-label">Import</span>
          </button>
        </div>
      </div>
    </div>

    <div class="row search" :class="colorBottomButton">
      <div class="col-md-12">
        <div class="contactButtonContainer">
          <f7-grid no-gutter>
            <f7-col width="50" class="pilotageTabController">
              <f7-link class='pilotageLink' v-bind:class="{tabActive_P: currentTAB === 'sent'}" tab-link="#sentRTPtab" @click="changeActiveTab('sent')" :tab-link-active="currentTAB === 'sent'">Sent</f7-link>
            </f7-col>
            <f7-col width="50" class="pilotageTabController">
              <f7-link class='pilotageLink' v-bind:class="{tabActive_P: currentTAB === 'draft'}" tab-link="#draftRTPtab" @click="changeActiveTab('draft')" :tab-link-active="currentTAB === 'draft'">In Progress</f7-link>
            </f7-col>
          </f7-grid>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <f7-tabs>
          <f7-tab id="sentRTPtab" ref="sentRTPtabTab" tab-active>
            <sent-rtp ref="sentRTP"
              @pullToRefreshDone="$f7.pullToRefreshDone()"
              @paymentsNumber="setPaymentsNumber($event)"
            ></sent-rtp>
          </f7-tab>
          <f7-tab id="draftRTPtab" ref="draftRTPtabTab" tab-active>
            <drafts-rtp ref="refdrafts"></drafts-rtp>
          </f7-tab>
        </f7-tabs>
      </div>
    </div>
</div>
  </div>
  </div>
</template>

<script>
// import {errorMessageAlert} from '@/helpers/alert'
import TransactionsList from '@/pages/requests/TransactionsList.vue'
import SentRTP from './sendbox/SentRTP.vue'
import DraftsRTP from './sendbox/Drafts.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import moment from 'moment'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'Sentbox',
  props: ['tab'],
  components: {
    'page-nav-bar': pageNavBar,
    'transactions-list': TransactionsList,
    'bottom-toolbar': bottomToolbar,
    'sent-rtp': SentRTP,
    'drafts-rtp': DraftsRTP
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      serviceName: 'MoneyRoad',
      sendboxMessages: [],
      afterBack: false,
      paymentsNumber: 0,
      currentTAB: '',
      clearance: '',
      accountType: ''
    }
  },
  created () {
    let that = this

    // Initialisation de paramètres
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    // Initialisation de la fonctionnalité Pull To Refresh
    this.$f7.initPullToRefresh()

    // En cas de première connexion de l'utilisateur
    if (this.$engine.user.getIsFirstLogin() === '1') {
      this.$engine.user.setIsFirstLogin('0')
      that.$f7.openPanel('left')
      that.$engine.services.payments.getPaymentsNotReadNumber()
      .then(resp => {
        if (resp.data.requestNotReadNumber > 99) {
          that.Dom7('.numberBadge').text('99+')
        } else {
          that.Dom7('.numberBadge').text(resp.data.requestNotReadNumber)
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  },
  mounted () {
    // Initialisation du type de compte
    this.accountType = this.$engine.user.get().type
    // Initialisation des droit sur le service RTP
    this.clearance = this.$engine.user.get().clearance['Payments']

    // Initialisation du tab actuel (messages envoyés ou brouillons)
    if ((typeof this.tab) !== 'undefined' && this.tab === 'draft') {
      this.currentTAB = 'draft'
      this.$refs.draftRTPtabTab.show()
    } else {
      this.currentTAB = 'sent'
      this.$refs.sentRTPtabTab.show()
    }
  },
  beforeDestroy () {
    this.$f7.onPageAfterBack('details-page', function (page) {}).remove()
  },
  computed: {
    // Détermine si l'utilisateur a un niveau de droit d'administration
    isAdmin: function () {
      return this.accountType === '2' || (this.accountType === '1' && this.clearance === '1')
    }
  },
  methods: {
    // FONCTIONS RELATIVES A SENT RTP
    /** Redirection vers le formulaire de création de RTP */
    openCreateRequest () {
      loadPage(this, {url: '/payments/newPayments/'})
    },

    /** Rafraichissment des messages envoyés */
    refreshSentRTP () {
      this.$refs.sentRTP.refreshSendbox()
    },

    /** Extraction CSV des messages envoyés */
    extractCSV (sendboxMessages) {
      let firstLine = 'NbStatus;Status;remittanceInformation;attachmentId;creditorName;creationDate\r\n'
      let lines = ''
      for (let datas in sendboxMessages) {
        lines += sendboxMessages[datas]['stat'] + ';' +
        TransactionsList.methods.getStatusLabel(sendboxMessages[datas]['stat'], sendboxMessages[datas]['negotStatus'], 1) + ';' +
        sendboxMessages[datas]['remitInfo'] + ';' +
        sendboxMessages[datas]['hasAttachment'] + ';' +
        sendboxMessages[datas]['crNm'] + ';' +
        sendboxMessages[datas]['crtnDt'] + '\r\n'
      }

      let data = firstLine + lines
      let today = moment()
      const linkSource = 'data:text/csv;charset:utf-8,' + data
      const downloadLink = document.createElement('a')
      const fileName = 'sentRequestToPay' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },

    // FONCTION RELATIVES A DRAFTS
    /** Rafraichissment des brouillons */
    refreshDrafts () {
      this.$refs.refdrafts.refreshDrafts()
    },

    /** Extraction CSV des brouillons */
    extractDraftsCSV () {
      this.$refs.refdrafts.extractCSV()
    },

    // AUTRES FONCTIONS
    /**
     * Fonction appelée par l'évènement Pull To Refresh
     * @event
     */
    onPullToRefresh: function () {
      if (this.currentTAB === 'sent') {
        this.refreshSentRTP()
      } else if (this.currentTAB === 'draft') {
        this.refreshDrafts()
      }
    },

    /**
    * Modifie le tab affiché
    * @param {string} value - Valeur du tab que l'on veut afficher ('sent'/'draft')
    */
    changeActiveTab (value) {
      if (value === 'sent' || value === 'draft') {
        this.currentTAB = value
      }
    },

    /**
    * Assigne à paymentsNumber le nombre total de messages envoyés
    * @param {int} value - Nombre total de message senvoyé
    */
    setPaymentsNumber (value) {
      this.paymentsNumber = value
    }
  }
}
</script>

<style scoped>
  .tabActive {
    background-color: #12bcf1;
    color: white;
  }
  .new-button.pull-right {
    width: 125px;
    margin-right: 0px;
  }
  .page {
    overflow-y: auto;
  }
  .rowBackgroundImage {
    background-image: url('../../../assets/static/images/MenuFont.png');
    background-size: contain;
  }
  @media (max-width: 768px) {
    .toolbarPageBottomBlank {
      height: 75px !important;
    }
  }
  @media (min-width: 993px) {
    .searchForm {
      margin-top: 0%;
    }
    .heightifLargeScreen {
      overflow-y: auto;
      height: 105%;
    }
    .contactButtonContainer {
      margin-top: 0% !important;
      margin-left:0px
    }
  }

</style>



// WEBPACK FOOTER //
// CMSendboxPage.vue?1c070516